import {
    FETCH_TEAM_DETAILS,
    FETCH_TEAM_DETAILS_FAIL,
    FETCH_TEAM_DETAILS_SUCCESS
} from './actionTypes';

const initialState = {
    data: {},
    error: null,
    loading: false,
    loaded: false
};

export function teamDetailsReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_TEAM_DETAILS:
            return {
                ...initialState,
                loading: true
            };
        case FETCH_TEAM_DETAILS_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loaded: true,
                loading: false
            };
        case FETCH_TEAM_DETAILS_FAIL: {
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        }
        default:
            return state;
    }
}
